(() => {
  const elements = document.querySelectorAll('[js-dynamic-country]');
  if (!elements.length) return;

  const formatCountryKey = (code) => {
    return code.trim().toLowerCase();
  };

  const getGeo = async () => {
    let geo = window.wigiwama?.geolocation;

    if (!geo) {
      try {
        geo = await window.wigiwama.functions.queryLocale();
      } catch (e) {
        console.warn('Locale detection failed', e);
        return null;
      }
    }

    return geo;
  };

  const updateElement = async (el) => {
    el.setAttribute('state', 'loading');

    const geo = await getGeo();
    const countryCode = geo?.countryCode;
    const countryName = geo?.countryName;

    const key = countryCode ? formatCountryKey(countryCode) : null;
    const days = key && el.getAttribute(`data-country-${key}`);

    if (!days) {
      const fallbackHTML = el.querySelector('.delivery-fallback')?.innerHTML || '';
      el.innerHTML = fallbackHTML;
      el.setAttribute('state', 'ready');
      return;
    }

    const templateHTML = el.querySelector('.delivery-template')?.innerHTML || '';
    const resultHTML = templateHTML
      .replaceAll('[[ country ]]', countryName)
      .replaceAll('[[ days ]]', `<strong>${days}</strong>`);

    el.innerHTML = resultHTML;
    el.setAttribute('state', 'ready');
  };

  elements.forEach(updateElement);
})();
